var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRow23(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4853 8.12744H4.13309C1.85234 8.12744 0 9.9757 0 12.2605V37.871C0 40.1517 1.84826 42.0041 4.13309 42.0041H11.4894V8.12744H11.4853ZM6.25471 28.2094C4.51661 28.2094 3.109 26.8018 3.109 25.0637C3.109 23.3256 4.51661 21.918 6.25471 21.918C7.99281 21.918 9.40043 23.3256 9.40043 25.0637C9.40043 26.8018 7.99281 28.2094 6.25471 28.2094Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1384 24.5863C40.0294 27.6953 37.5487 28.3522 36.0187 28.3522C34.9783 28.3522 34.3173 28.0584 34.0807 27.9319L33.5299 27.6382L33.2361 27.0873C32.9056 26.4631 31.5062 23.1011 36.5817 18.0256L46.484 8.12329H13.5254V41.9958H48.9647C51.2454 41.9958 53.0978 40.1476 53.0978 37.8627V14.6187L43.1384 24.5781V24.5863Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3242 20.2126C33.9092 24.0112 35.0394 26.1328 35.0394 26.1328C35.0394 26.1328 37.1569 27.2589 40.9595 23.848L37.3283 20.2167L37.3242 20.2126Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3542 11.1429L38.7463 18.7507L42.4161 22.4205L50.0239 14.8127L46.3542 11.1429Z",
    fill: "#22499D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6253 0.542733C59.8991 -0.183515 58.724 -0.183515 57.9978 0.542733L56.6514 1.88915L56.631 1.86875C56.3535 1.59131 55.9047 1.59131 55.6314 1.86875L47.8018 9.69836L51.4738 13.3704L59.3034 5.54079C59.5809 5.26335 59.5809 4.81454 59.3034 4.54118L59.283 4.52078L60.6294 3.17436C61.3557 2.44812 61.3557 1.27306 60.6294 0.546813L60.6253 0.542733Z",
    fill: "#22499D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_79"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.1681,
    height: 42,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRow23);
export default __webpack_public_path__ + "static/media/row2-3.3764904e24e7907dea171b69451ec488.svg";
export { ForwardRef as ReactComponent };